import {
  Component,
  OnInit,
  inject,
  DestroyRef,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

import { PaginatorModule } from 'primeng/paginator';
import { MessageService } from 'primeng/api';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  RondaService,
  EscalaService,
  PostoService,
  EfetivoService,
} from '@core/services/domain-services';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';
import { Ronda } from '@core/models/models';
import { DrawerModule } from 'primeng/drawer';
import { Select } from 'primeng/select';
import {
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
} from '@angular/forms';
import { DatePicker } from 'primeng/datepicker';
import { forkJoin } from 'rxjs';
import { DetalheRondaComponent } from './detalhe-ronda/detalhe-ronda.component';

@Component({
  selector: 'app-rondas',
  standalone: true,
  imports: [
    CommonModule,
    SkeletonModule,

    PaginatorModule,
    EmptyStateComponent,
    FormsModule,
    DrawerModule,
    Select,
    ReactiveFormsModule,
    DatePicker,
    DetalheRondaComponent,
  ],

  templateUrl: './rondas.component.html',
  styleUrl: './rondas.component.scss',
})
export class RondasComponent implements OnInit {
  private readonly svc = inject(RondaService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly escalasvc = inject(EscalaService);
  private readonly postosvc = inject(PostoService);
  private readonly efetivosvc = inject(EfetivoService);
  private readonly msg = inject(MessageService);
  private readonly fb = inject(FormBuilder);

  ocorrencias: any[] = [];

  estadoOptions = [
    { label: 'Concluída', value: true },
    { label: 'Não concluída', value: false },
  ];
  rondas: any[] = [];
  ronda: any;
  showRendaDetallhe: boolean = false;
  tipos: any[] = [];
  postos: any[] = [];
  escalas: any[] = [];
  efetivos: any[] = [];
  TipoOcorrencia: any[] = [];
  criticidades: any[] = [];
  showNewRonda: boolean = false;
  loadNewRonda: boolean = false;
  filtrosForm!: FormGroup;
  filtrosPainelAberto = false;
  escalaId = '';
  loading = false;
  page = 1;
  pageSize = 20;
  totalRecords = 0;
  ngOnInit(): void {
    this.load();
    this.initForm();
    this.loadDropdowns();
  }

  initForm() {
    this.filtrosForm = this.fb.group({
      IdEscala: [''],
      IdPosto: [null],
      IdEfetivo: [null],
      Concluida: [null],
      DataDe: [''],
      DataAte: [''],
    });
  }

  load(queryParams: Record<string, any> = {}): void {
    this.loading = true;

    const params: Record<string, any> = {
      pageNumber: this.page,
      pageSize: this.pageSize,
      OrderBy: 'id desc',
      ...queryParams,
    };

    this.svc
      .getAll(params)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          this.rondas = res.data ?? [];
          this.totalRecords = res.totalRecords ?? 0;
          this.loading = false;
          this.cdr.detectChanges();
        },
        error: () => {
          this.loading = false;
          this.cdr.detectChanges();
        },
      });
  }

  onPageChange(ev: any): void {
    this.page = (ev.page ?? 0) + 1;
    this.pageSize = ev.rows ?? this.pageSize;
    this.load();
  }

  limparFiltros(): void {
    this.filtrosForm.reset();
    this.page = 1;
    this.load();
  }

  aplicarFiltrosDrawer(): void {
    const val = this.filtrosForm.value;
    const params: Record<string, any> = {};
    Object.entries(val).forEach(([k, v]) => {
      if (v !== null && v !== undefined && v !== '') params[k] = v;
    });
    this.filtrosPainelAberto = false;
    this.page = 1;
    this.aplicarFiltros(params);
  }

  aplicarFiltros(filtros: any): void {
    this.load(filtros);
  }

  getConformidade(r: Ronda): number {
    if (!r.pontosCriticos?.length) return 100;
    const concluidos = r.pontosCriticos.filter((p) => p.concluido).length;
    return Math.round((concluidos / r.pontosCriticos.length) * 100);
  }

  getConformidadeClass(r: Ronda): string {
    const p = this.getConformidade(r);
    if (p === 100) return 'badge-ativo';
    if (p >= 80) return 'badge-alta';
    return 'badge-urgente';
  }

  criarRonda() {
    this.showNewRonda = true;
  }

  submitRonda() {
    if (!this.escalaId) {
      this.msg.add({
        severity: 'warn',
        summary: 'Selecione a escala',
        detail: 'Tem de selecionar a escala para continuar',
      });
      return;
    }

    this.loadNewRonda = true;
    const payload = {
      idEscala: this.escalaId,
    };

    this.svc.create(payload).subscribe({
      next: (res: any) => {
        this.showNewRonda = false;
        this.loadNewRonda = false;
        this.msg.add({
          severity: 'success',
          summary: 'Registo guardado',
          detail: 'Ronda salva com sucess',
        });
        this.load();
      },
      error: (err) => {
        console.error(err);
        this.loadNewRonda = false;
      },
    });
  }

  loadDropdowns() {
    forkJoin({
      postos: this.postosvc.getAll({ pageSize: 100 }),
      efetivos: this.efetivosvc.getAll({ pageSize: 100 }),
      escalas: this.escalasvc.getAll({ pageSize: 100 }),
    }).subscribe((response) => {
      // Enums
      // if (response.tipoOcorrencia?.data) {
      //   this.tipos = Object.entries(response.tipoOcorrencia.data).map(
      //     ([key, value]) => ({
      //       value: Number(key),
      //       label: value,
      //     })
      //   );
      // }

      // Listas comuns
      if (response.postos?.data) {
        this.postos = response.postos.data.map((item: any) => ({
          label: item.nome,
          value: item.id,
        }));
      }
      if (response.efetivos?.data) {
        this.efetivos = response.efetivos.data.map((item: any) => ({
          label: item.nome,
          value: item.id,
        }));
      }
      if (response.escalas?.data) {
        this.escalas = response.escalas.data.map((item: any) => ({
          label: item.nomeTurno + ' - ' + item.nomePosto,
          value: item.id,
        }));
      }

      this.cdr.detectChanges();
    });
  }

  openDetalhe(ronda: any) {
    this.ronda = ronda;
    this.showRendaDetallhe = true;
  }
}
